import { useEffect } from 'react';
import { isClient } from '../helpers/accessibility';
import { useFunction } from './useFunction';
export const useWindowEventListener = (eventName, callback, disabled = false, capture = false) => {
  const handler = useFunction(callback);
  useEffect(() => {
    if (disabled || !isClient()) {
      return;
    }
    window.addEventListener(eventName, handler, {
      capture
    });
    return () => window.removeEventListener(eventName, handler);
  }, [disabled, eventName]);
  useEffect(() => () => window.removeEventListener(eventName, handler), []);
};